import { PaletteSelector } from "@/components/admin/PaletteSelector";

export default function ColorPalettesPage() {
  return (
    <div className="container mx-auto py-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold tracking-tight">Paletas de Cores</h1>
        <p className="text-muted-foreground">
          Gerencie as paletas de cores do sistema e crie temas personalizados.
        </p>
      </div>
      <PaletteSelector />
    </div>
  );
}
